export default __webpack_public_path__ + "media/faq/check-939494dc.svg";